<app-shared-modal title="Create Tenant">
  <div class="loadingDiv" *ngIf="isCreating">
    <div class="loader"></div>
  </div>
    <form [formGroup]="tenantForm" (ngSubmit)="createTenant()">
      <div class="form-group">
        <label for="name" class="form-control-label">Tenant Name (alphanumeric only)<span class="required">*</span></label>
        <input type="text" formControlName="name" class="form-control"  [pattern]="'^[a-zA-Z0-9]+$'" (change)="onTenantNameChange()">
        <div *ngIf="tenantForm.controls.name.invalid && tenantForm.controls.name.dirty" class="form-control-feedback">
            <span *ngIf="tenantForm.controls.name.errors?.required || tenantForm.controls.name.errors?.whitespace">Tenant Name is required.</span>
            <span *ngIf="tenantForm.controls.name.errors?.maxlength">Tenant Name should not exceed 150 characters.</span>
            <span *ngIf="tenantForm.controls.name.errors?.pattern">Tenant Name should be alphanumeric only.</span>
            <span *ngIf="tenantForm.controls.name.errors?.tenantnameexists">Tenant Name is already in use.</span>
        </div>
      </div>      
      <div class="d-flex">
        <button type="button" class="btn btn-secondary" [disabled]="loading" (click)="onCloseModal();">Cancel</button>
        <button type="submit" class="btn btn-primary ml-auto" [disabled]="!tenantForm.valid || loading">
          Create
          <i class="fa fa-spinner fa-spin ml-1" *ngIf="loading"></i>
        </button>
      </div>
    </form>
  </app-shared-modal>